module.exports = __webpack_public_path__ + "static/img/pro_tab5.4a84ff6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab5.jpg
// module id = Kt+3
// module chunks = 171